import { QuestionExplanation } from '../../types'

export const TIJDGELD_EXPLANATIONS: Record<string, QuestionExplanation> = {
  'TIJD-PAT-L1-001': {
    id: 'TIJD-PAT-L1-001',
    explanation:
      'De getallen springen steeds 4 verder. Kijk: 3 + 4 = 7, 7 + 4 = 11, 11 + 4 = 15. Dus na 15 komt 19.',
    distractorExplanations: {
      '1': 'Je deed +1. Maar de sprongen zijn +4!',
      '2': 'Je deed +3. Maar kijk goed: van 3 naar 7 is +4!',
      '3': 'Je deed +5. Maar de sprongen zijn +4: 3, 7, 11, 15, 19.',
    },
    visualAid: {
      type: 'numberline',
      data: {
        start: 0,
        end: 24,
        highlight: [3, 7, 11, 15, 19],
        label: 'Patroon: +4',
      },
      showWhen: 'wrong',
    },
  },
  'TIJD-TAB-L1-001': {
    id: 'TIJD-TAB-L1-001',
    explanation: '8 is het hoogste getal. Dus op dinsdag was het het warmst.',
    distractorExplanations: {
      '1': '5 graden is kouder dan 8 graden.',
      '2': '6 graden is kouder dan 8 graden.',
      '3': 'De getallen zijn verschillend: 5, 8 en 6.',
    },
    visualAid: {
      type: 'ratio',
      data: {
        headers: ['Dag', 'Temperatuur'],
        rows: [
          ['Maandag', '5°C'],
          ['Dinsdag', '8°C'],
          ['Woensdag', '6°C'],
        ],
        highlightRow: 1,
      },
      showWhen: 'wrong',
    },
  },
  'TIJD-DUR-L2-001': {
    id: 'TIJD-DUR-L2-001',
    explanation:
      'Een half uur is 30 minuten. Tel op: 15 + 30 = 45 minuten. Dus 09:45 uur.',
    distractorExplanations: {
      '1': 'Je hebt er maar 15 minuten bijgedaan (een kwartier). Maar een half uur is 30 minuten!',
      '2': 'Dit is een heel uur later. Maar de trein gaat elk half uur!',
      '3': 'Rekenfoutje: 15 + 30 = 45, niet 55.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Tijd Optellen',
        content:
          'Een half uur = 30 minuten. Tel de minuten op: 15 + 30 = 45 minuten.',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'TIJD-PAT-L2-001': {
    id: 'TIJD-PAT-L2-001',
    explanation:
      'Elk week komt er €2 bij (de tafel van 2). Week 4 is €8, dus Week 5 is €10.',
    distractorExplanations: {
      '1': 'Dit is Week 4! De vraag gaat over Week 5.',
      '2': 'Je bent te ver gegaan. Dit is Week 6!',
      '3': 'Je hebt naar het weeknummer gekeken. Maar het bedrag is het weeknummer keer 2!',
    },
    visualAid: {
      type: 'ratio',
      data: {
        headers: ['Week', 'Zakgeld'],
        rows: [
          ['Week 1', '€ 2'],
          ['Week 2', '€ 4'],
          ['Week 3', '€ 6'],
          ['Week 4', '€ 8'],
          ['Week 5', '€ 10'],
        ],
        highlightRow: 4,
      },
      showWhen: 'wrong',
    },
  },
  'TIJD-TAB-L3-001': {
    id: 'TIJD-TAB-L3-001',
    explanation:
      'Tel alles op: € 5,00 (pannenkoek) + € 1,50 (spek) + € 1,00 (kaas) = € 7,50.',
    distractorExplanations: {
      '1': 'Je bent de kaas vergeten! Tel ook de € 1,00 voor kaas erbij.',
      '2': 'Je bent het spek vergeten! Tel ook de € 1,50 voor spek erbij.',
      '3': 'Je hebt iets dubbel geteld. Check: 5 + 1,50 + 1 = 7,50.',
    },
    visualAid: {
      type: 'ratio',
      data: {
        headers: ['Item', 'Prijs'],
        rows: [
          ['Pannenkoek', '€ 5,00'],
          ['+ Spek', '€ 1,50'],
          ['+ Kaas', '€ 1,00'],
          ['Totaal', '€ 7,50'],
        ],
        highlightRow: 3,
      },
      showWhen: 'wrong',
    },
  },
  'TIJD-TAB-L3-002': {
    id: 'TIJD-TAB-L3-002',
    explanation: 'Je reist eerst 10 km, dan nog 5 km. Tel op: 10 + 5 = 15 km.',
    distractorExplanations: {
      '1': 'Je hebt afgetrokken (10 - 5). Maar je reist verder, dus je moet optellen!',
      '2': 'Je hebt vermenigvuldigd (10 $\\times$ 5). Maar bij afstanden tel je op!',
      '3': 'Rekenfoutje. Check: 10 + 5 = 15.',
    },
    visualAid: {
      type: 'ratio',
      data: {
        headers: ['Van', 'Naar', 'Afstand'],
        rows: [
          ['A', 'B', '10 km'],
          ['B', 'C', '5 km'],
          ['A', 'C (via B)', '15 km'],
        ],
        highlightRow: 2,
      },
      showWhen: 'wrong',
    },
  },

  // Klokkijken tot op de seconde
  'TIJD-KLOK-L1-001': {
    id: 'TIJD-KLOK-L1-001',
    explanation: '1 minuut heeft 60 seconden. Dit moet je uit je hoofd kennen!',
    distractorExplanations: {
      '1': '100 seconden is te veel. 1 minuut = 60 seconden.',
      '2': '30 seconden is een half minuut.',
      '3': '120 seconden is 2 minuten.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Tijd Omrekenen',
        content: '1 minuut = 60 seconden. Onthoud dit goed!',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'TIJD-KLOK-L1-002': {
    id: 'TIJD-KLOK-L1-002',
    explanation:
      "14:30:00 betekent 14 uur en 30 minuten (en 0 seconden). 14:30 is half drie 's middags.",
    distractorExplanations: {
      '1': 'Half twee is 13:30, niet 14:30.',
      '2': 'Drie uur is 15:00, niet 14:30.',
      '3': 'Half vier is 15:30, niet 14:30.',
    },
  },
  'TIJD-KLOK-L1-003': {
    id: 'TIJD-KLOK-L1-003',
    explanation:
      'Een half minuut is de helft van 60 seconden. 60 : 2 = 30 seconden.',
    distractorExplanations: {
      '1': '60 seconden is een hele minuut, niet een half.',
      '2': '15 seconden is een kwart minuut.',
      '3': '45 seconden is driekwart minuut.',
    },
  },
  'TIJD-KLOK-L2-001': {
    id: 'TIJD-KLOK-L2-001',
    explanation:
      'De klok toont 09:15:30. De laatste twee cijfers (30) zijn de seconden. Het is dus 30 seconden na kwart over negen.',
    distractorExplanations: {
      '1': '15 zijn de minuten, niet de seconden!',
      '2': '45 seconden zou 09:15:45 zijn.',
      '3': '1 minuut zou 09:16:00 zijn.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Digitale Klok Lezen',
        content:
          'Formaat: uu:mm:ss (uren:minuten:seconden). De laatste twee cijfers zijn altijd de seconden!',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'TIJD-KLOK-L2-002': {
    id: 'TIJD-KLOK-L2-002',
    explanation:
      '2 minuten = 2 × 60 = 120 seconden. Plus 45 seconden = 165 seconden totaal.',
    distractorExplanations: {
      '1': 'Je bent de 2 minuten vergeten om te rekenen! 2 min = 120 sec.',
      '2': 'Rekenfout. 2 × 60 = 120, plus 45 = 165.',
      '3': 'Je hebt verkeerd gerekend. Check: 120 + 45 = 165.',
    },
  },
  'TIJD-KLOK-L2-003': {
    id: 'TIJD-KLOK-L2-003',
    explanation:
      'Van 11:58:40 naar 12:00:00. Eerst naar 11:59:00 (20 sec), dan naar 12:00:00 (60 sec). Totaal: 20 + 60 = 80 seconden.',
    distractorExplanations: {
      '1': '60 seconden is maar tot 11:59:40. Je moet nog 20 seconden verder!',
      '2': '120 seconden is te veel. Check: 20 + 60 = 80.',
      '3': '20 seconden is maar tot 11:59:00. Je moet nog een minuut verder!',
    },
  },
  'TIJD-KLOK-L3-001': {
    id: 'TIJD-KLOK-L3-001',
    explanation:
      '58,75 seconden is minder dan 60 seconden, dus het is 0 minuten en 58,75 seconden. (Of: 58 seconden en 75 honderdsten).',
    distractorExplanations: {
      '1': 'Dit zou betekenen dat 58 minuten en 75 seconden, maar dat kan niet!',
      '2': 'Rekenfout. 58,75 seconden is nog geen minuut.',
      '3': '59 seconden is afgerond, maar de vraag vraagt om het exacte getal.',
    },
  },
  'TIJD-KLOK-L3-002': {
    id: 'TIJD-KLOK-L3-002',
    explanation:
      'Van 23:59:45 naar 00:00:00 (middernacht) is 15 seconden. 60 - 45 = 15.',
    distractorExplanations: {
      '1': '45 seconden is hoeveel er al voorbij is, niet hoeveel er nog komt!',
      '2': '60 seconden is een hele minuut, maar we zitten al bij 45 seconden.',
      '3': '30 seconden zou 23:59:30 zijn.',
    },
  },
  'TIJD-KLOK-L3-003': {
    id: 'TIJD-KLOK-L3-003',
    explanation:
      'Stap 1: 3 minuten = 3 × 60 = 180 seconden.\nStap 2: Plus 15 seconden = 180 + 15 = 195 seconden.\nHet liedje duurt 195 seconden.',
    distractorExplanations: {
      '1': 'Je hebt de minuten en seconden door elkaar gehaald. 3 minuten is 180 seconden, niet 315.',
      '2': '180 seconden is alleen de 3 minuten. Je moet nog de 15 seconden erbij tellen!',
      '3': 'Rekenfout. Check: 3 × 60 = 180, dan 180 + 15 = 195.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Minuten naar Seconden',
        content:
          '1 minuut = 60 seconden. Dus 3 minuten = 3 × 60 = 180 seconden. Tel de extra seconden erbij op!',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },

  // GELD VRAGEN
  'TIJD-GELD-L1-001': {
    id: 'TIJD-GELD-L1-001',
    explanation:
      '50 cent past 5 keer in €2,50. 50 + 50 = €1. Nog eens 50 + 50 = €2. En nog 50 cent erbij is €2,50.',
    distractorExplanations: {
      '1': '4 munten is €2,00. Je komt 50 cent tekort.',
      '2': '3 munten is €1,50. Je komt €1,00 tekort.',
      '3': '2 munten is €1,00. Je komt €1,50 tekort.',
    },
  },
  'TIJD-GELD-L1-002': {
    id: 'TIJD-GELD-L1-002',
    explanation: '3 munten van €1 is samen €3. (1 + 1 + 1 = 3)',
    distractorExplanations: {
      '1': '€2 is te weinig. Je hebt 3 munten.',
      '2': '€4 is te veel. Je hebt maar 3 munten.',
      '3': '€1 is maar één munt.',
    },
  },
  'TIJD-GELD-L1-003': {
    id: 'TIJD-GELD-L1-003',
    explanation:
      '50 cent min 25 cent is 25 cent. (50 - 25 = 25). Je krijgt dus 25 cent terug.',
    distractorExplanations: {
      '1': '50 cent is wat je gaf, niet wat je terugkrijgt.',
      '2': '75 cent is meer dan je gaf!',
      '3': '0 cent betekent dat het precies 50 cent kostte, maar het was 25 cent.',
    },
  },
  'TIJD-GELD-L1-004': {
    id: 'TIJD-GELD-L1-004',
    explanation:
      '2 munten van 50 cent is samen 100 cent. En 100 cent is hetzelfde als €1.',
    distractorExplanations: {
      '1': '€2 is 4 munten van 50 cent.',
      '2': '50 cent is maar één munt.',
      '3': '€1,50 is 3 munten van 50 cent.',
    },
  },
  'TIJD-GELD-L1-005': {
    id: 'TIJD-GELD-L1-005',
    explanation:
      'Je hebt 2 munten van €1. Dat is samen €2. Het broodje kost ook €2. Dus je hebt precies genoeg!',
    distractorExplanations: {
      '1': 'Nee, je hebt €2 en het kost €2. Dat is niet te weinig.',
      '2': 'Nee, je houdt niets over, want het kost precies wat je hebt.',
      '3': 'Jawel, je hebt precies genoeg geld.',
    },
  },
  'TIJD-GELD-L2-001': {
    id: 'TIJD-GELD-L2-001',
    explanation:
      'Je hebt al €5 (het biljet). Je moet nog €2 betalen. Je hebt munten van €1. Dus je hebt 2 munten van €1 nodig. €5 + €2 = €7. Precies genoeg!',
    distractorExplanations: {
      '1': '3 munten erbij is €8 totaal. Dan betaal je te veel en krijg je €1 terug.',
      '2': '5 munten is €5. Samen met het briefje is dat €10. Dat kan, maar 2 munten is genoeg.',
      '3': '7 munten is €7. Maar je hebt al een biljet van €5! Je hebt maar 2 munten nodig.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Geld Samenstellen',
        content:
          'Je hebt al €5. Hoeveel moet je nog betalen? €7 - €5 = €2. Dus 2 munten van €1.',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'TIJD-GELD-L2-002': {
    id: 'TIJD-GELD-L2-002',
    explanation:
      '3 biljetten van €1 = €3. 1 munt van 50¢ + 1 munt van 25¢ = 75¢. Samen is dat €3,75.',
    distractorExplanations: {
      '1': 'Dit is €5 + €1 + 75¢ = €6,75. Veel te veel!',
      '2': 'Dit is €3 + 75¢ = €3,75. Wacht, deze optie is ook goed! Maar optie C gebruikt briefjes en munten.',
      '3': '7 munten van 50¢ is €3,50. Plus 25¢ is €3,75. Dit is ook goed! Maar meestal kiezen we de optie met briefjes.',
    },
  },
  'TIJD-GELD-L2-003': {
    id: 'TIJD-GELD-L2-003',
    explanation:
      '€5,00 - €3,75 = €1,25. Je kunt dit uitrekenen door eerst naar de €4 te tellen (25 cent) en dan naar de €5 (€1).',
    distractorExplanations: {
      '1': '€1,50 + €3,75 = €5,25. Dat klopt niet.',
      '2': '€2,25 is te veel wisselgeld.',
      '3': '€1,75 + €3,75 = €5,50. Dat klopt niet.',
    },
  },
  'TIJD-GELD-L2-004': {
    id: 'TIJD-GELD-L2-004',
    explanation:
      'Je hebt al €5. Je moet nog 50 cent betalen. Je hebt munten van 50 cent. Dus je hebt precies 1 munt nodig.',
    distractorExplanations: {
      '1': '2 munten is €1. Dan betaal je €6 totaal. Dat is te veel.',
      '2': '3 munten is €1,50. Veel te veel.',
      '3': '0 munten kan niet, want dan betaal je maar €5.',
    },
  },
  'TIJD-GELD-L2-005': {
    id: 'TIJD-GELD-L2-005',
    explanation: '€2,00 - €1,80 = €0,20. Dat is 20 cent.',
    distractorExplanations: {
      '1': '30 cent zou betekenen dat het €1,70 kostte.',
      '2': '10 cent zou betekenen dat het €1,90 kostte.',
      '3': '40 cent zou betekenen dat het €1,60 kostte.',
    },
  },
  'TIJD-GELD-L2-006': {
    id: 'TIJD-GELD-L2-006',
    explanation: '4 keer €2 = €8. (2 + 2 + 2 + 2 = 8)',
    distractorExplanations: {
      '1': '€6 is 3 munten van €2.',
      '2': '€4 is 2 munten van €2.',
      '3': '€10 is 5 munten van €2.',
    },
  },
  'TIJD-GELD-L2-007': {
    id: 'TIJD-GELD-L2-007',
    explanation:
      '€20,00 - €12,50 = €7,50. Reken eerst van 12,50 naar 13,00 (50 cent). Dan van 13 naar 20 (7 euro). Samen €7,50.',
    distractorExplanations: {
      '1': '€8,50 is te veel. 12,50 + 8,50 = 21,00.',
      '2': '€6,50 is te weinig. 12,50 + 6,50 = 19,00.',
      '3': '€7 zou betekenen dat het €13,00 kostte.',
    },
  },
  'TIJD-GELD-L2-008': {
    id: 'TIJD-GELD-L2-008',
    explanation:
      'Alle opties kloppen! A: €2 + 50¢ = €2,50. B: 5 × 50¢ = €2,50. C: €2 + 25¢ + 25¢ = €2,50. Dus "Alle bovenstaande" is het goede antwoord.',
    distractorExplanations: {
      '0': 'Dit klopt, maar de andere opties ook!',
      '1': 'Dit klopt ook, maar kijk verder!',
      '2': 'Dit klopt ook! Kies de optie die alles samenvat.',
    },
  },
  'TIJD-GELD-L3-001': {
    id: 'TIJD-GELD-L3-001',
    explanation:
      'Eerst reken je het wisselgeld uit: €10,00 - €2,85 = €7,15. De slimste combinatie gebruikt het minste aantal briefjes en munten: 1×€5 + 2×€1 + 1×10¢ + 1×5¢ = 4 stuks totaal.',
    distractorExplanations: {
      '1': 'Dit klopt wel (7×€1 + 10¢ + 5¢), maar je gebruikt 9 stuks. Dat is meer dan nodig!',
      '2': 'Er bestaat geen biljet van €2 in Nederland.',
      '3': 'Dit klopt wel (14×50¢ + 10¢ + 5¢), maar je gebruikt 16 stuks. Veel te veel!',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Slim Wisselgeld',
        content:
          'Gebruik altijd de grootste briefjes en munten eerst. Zo gebruik je het minste aantal!',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'TIJD-GELD-L3-002': {
    id: 'TIJD-GELD-L3-002',
    explanation:
      'Eerst uitrekenen wat je moet betalen: 3 × €1,45 = €4,35. Dan het wisselgeld: €5,00 - €4,35 = €0,65.',
    distractorExplanations: {
      '1': '€1,65 is te veel. Dan zou het €3,35 kosten.',
      '2': '€0,55 is te weinig. Dan zou het €4,45 kosten.',
      '3': '€1,55 is te veel.',
    },
  },
  'TIJD-GELD-L3-003': {
    id: 'TIJD-GELD-L3-003',
    explanation:
      'Je moet €15,75 maken. 1×€10 + 1×€5 = €15. Dan nog 75 cent: 1×50¢ + 1×25¢. Dit zijn maar 4 dingen (briefjes/munten).',
    distractorExplanations: {
      '1': '3×€5 = €15. Plus munten is 5 dingen. Dat is meer dan 4.',
      '2': '15 munten van €1 is heel veel munten!',
      '3': 'Dit is ook €15,75, maar je gebruikt veel meer munten.',
    },
  },
  'TIJD-GELD-L3-004': {
    id: 'TIJD-GELD-L3-004',
    explanation:
      'Eerst uitrekenen hoeveel je betaalt: 2 × €20 = €40. Dan het wisselgeld: €40,00 - €23,95 = €16,05.',
    distractorExplanations: {
      '1': 'Je hebt maar 1 biljet van €20 gebruikt. Maar je betaalt met 2 biljetten!',
      '2': 'Je hebt opgeteld in plaats van afgetrokken.',
      '3': 'Rekenfout. Check je berekening nog eens stap voor stap.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Wisselgeld Berekenen',
        content:
          'Stap 1: Reken uit hoeveel je betaalt. Stap 2: Trek de prijs eraf.',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'TIJD-GELD-L3-005': {
    id: 'TIJD-GELD-L3-005',
    explanation:
      'Reken elke soort apart: 8 munten van €2 = €16. Dan 5 munten van €1 = €5. Dan 4 munten van 50¢ = €2. Tel alles op: €16 + €5 + €2 = €23.',
    distractorExplanations: {
      '1': 'Je hebt een soort munt vergeten of verkeerd gerekend.',
      '2': 'Rekenfout bij het optellen. Check elke soort munt apart.',
      '3': 'Je hebt iets dubbel geteld of verkeerd berekend.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Geld Tellen',
        content:
          'Reken elke soort munt apart uit. Tel dan alle bedragen bij elkaar op.',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'TIJD-GELD-L3-006': {
    id: 'TIJD-GELD-L3-006',
    explanation:
      'Je hebt €34,99 nodig. Na 6 weken heb je 6 × €5 = €30. Dat is te weinig. Na 7 weken heb je 7 × €5 = €35. Dat is genoeg!',
    distractorExplanations: {
      '1': 'Na 6 weken heb je pas €30. Je komt dan nog €4,99 tekort.',
      '2': 'Na 8 weken heb je €40. Dat is ook genoeg, maar je kon het al na 7 weken kopen.',
      '3': 'Na 5 weken heb je pas €25.',
    },
  },
}
